import URLS from '@/store/urls';
import apiCall from '@/store/apiCall';

const uploadFile = (file, folder = 'frame-display-images') => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('folder', folder);
  return apiCall({
    type: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    url: URLS.fileUpload,
    body: formData,
    isToken: true,
  });
};

export default uploadFile;
